import { NameValue } from '@infodata-group/inf-commons';

export class Communication {
  public contact: string;
  public pref: any;
  public tel: string;
  public type: NameValue = new NameValue('', '');

  convert(item: any): Communication {
    const communication = new Communication();
    communication.contact = item.Contact;
    communication.pref = item.Pref;
    communication.tel = item.Tel;
    communication.type.name = item.Type?.Id;
    communication.type.value = item.Type?.Label;
    return communication;
  }
}
